module.exports = __webpack_public_path__ + "img/material-kid-xl.ef5f76ad.png";